import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_031c01f6-1122-4ae8-87ee-69acab3ae0f1/artifacts/kw4zjnmy_ava.jpeg";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <img src={LOGO_URL} alt="Andaman Avalon" className="h-16 w-auto mb-4 brightness-0 invert" />
            <p className="text-primary-foreground/80 mb-4">
              Your trusted partner for unforgettable Andaman experiences. We craft personalized tours that capture the magic of these pristine islands.
            </p>
            <div className="flex space-x-4">
              <a href="#" data-testid="social-facebook" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" data-testid="social-instagram" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" data-testid="social-twitter" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-secondary">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/home" data-testid="footer-home" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/packages" data-testid="footer-packages" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Tour Packages
                </Link>
              </li>
              <li>
                <Link to="/blog" data-testid="footer-blog" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Travel Blog
                </Link>
              </li>
              <li>
                <Link to="/write-review" data-testid="footer-write-review" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Write a Review
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-contact" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-secondary">Policies</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/cancellation-policy" data-testid="footer-cancellation" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Cancellation Policy
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" data-testid="footer-refund" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" data-testid="footer-privacy" className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-secondary">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Mail size={18} className="text-secondary mt-1" />
                <span className="text-primary-foreground/80">info@andamanavalon.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone size={18} className="text-secondary mt-1" />
                <div className="flex flex-col">
                  <a href="tel:+919933237121" className="text-primary-foreground/80 hover:text-secondary transition-colors">+91 99332 37121</a>
                  <a href="tel:+919434297214" className="text-primary-foreground/80 hover:text-secondary transition-colors">+91 94342 97214</a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="text-secondary mt-1 flex-shrink-0" />
                <span className="text-primary-foreground/80">Port Blair, Andaman & Nicobar Islands</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center">
          <p className="text-primary-foreground/60 text-sm">
            © 2026 Andaman Avalon. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;